<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <div style="display:flex;justify-content:flex-start;align-items:center;">
        <button-add @click="toAddPage"  v-if="permissionCodes.indexOf('044003001') !== -1"></button-add>
        <!-- <button-delete @deleteSelection="deleteSelection" v-if="permissionCodes.indexOf('036001003') !== -1"/> -->
        <!-- <button-upload :cathUrl="uploadUrl" @getpage="getPage" :onSuccess="onUploadSuccess" value="导入" v-if="permissionCodes.indexOf('036001004') !== -1"/> -->
      </div>
      <!-- <input-select selectTitle="物资类目筛选" :selectKey="'fix'" :selectData="fixTypeList"  @search="search"/> -->
      <!-- <input-search  placeholder="物资类目"  @search="searchKey" /> -->
    </div>
    <table-main :selection="false" :tableHead="tableHead" :tableData="tableData" :operationArr="operationArr" @deleteLine="deleteLine" :pageNum="requestData.pageNum" :pageSize="requestData.pageSize" @changePagination="changePagination" :total="total" @goToModifyPage="goToModifyPage" @faceAuthorizationRow="faceAuthorizationRow"/>

    <el-dialog
     :visible.sync="dialogVisible"
     width="30%">
      <div class="form-line">
            <div class="textBox">
              <b class="red">*</b>
              <span class="line-text">人脸库名称：</span>
            </div>
              <el-input v-model="formData.name" size="small" style="width: 280px"/>
          </div>
      <div class="form-line">
            <div class="textBox">
              <b class="red">*</b>
              <span class="line-text">人脸库类型：</span>
            </div>
              <el-select v-model="formData.type"
                        filterable
                        remote
                        disabled
                        v-if="flag"
                        reserve-keyword
                        size="small" style="width: 280px"
                        placeholder="请选择人脸库类型">
                <el-option v-for="item in typeList" :key="item.value"
                          :label="item.value" :value="item.value">
                </el-option>
              </el-select>
              <el-select v-model="formData.type"
                        filterable
                        remote
                        v-else
                        reserve-keyword
                        size="small" style="width: 280px"
                        placeholder="请选择人脸库类型">
                <el-option v-for="item in typeList" :key="item.value"
                          :label="item.value" :value="item.value">
                </el-option>
              </el-select>
          </div>
      <div class="form-line">
            <div class="textBox">
              <b class="red">*</b>
              <span class="line-text">摄像机通道：</span>
            </div>
              <el-select v-model="formData.deviceCode"
                        filterable
                        remote
                        disabled
                        v-if="flag"
                        reserve-keyword
                        :remote-method="remoteMethod"
                        size="small" style="width: 280px"
                        placeholder="请选择摄像机通道">
                <el-option v-for="item in cameraList" :key="item.key"
                          :label="item.label" :value="item.key">
                </el-option>
              </el-select>
              <el-select v-model="formData.deviceCode"
                        filterable
                        remote
                        v-else
                        reserve-keyword
                        :remote-method="remoteMethod"
                        size="small" style="width: 280px"
                        placeholder="请选择摄像机通道">
                <el-option v-for="item in cameraList" :key="item.key"
                          :label="item.label" :value="item.key">
                </el-option>
              </el-select>
          </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel" size="small">取 消</el-button>
        <el-button type="primary" @click="confirm()" size="small">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import ButtonDelete from "../../../components/Button/ButtonDelete";
import ButtonExport from "../../../components/common/buttons/button-export";
import ButtonUpload from "../../../components/common/buttons/button-upload";
import InputSearch from "../../../components/Input/InputSearch";
import InputSelect from "../../../components/Input/InputSelect";
import TableMain from "../../../components/Table/TableMain";
import { api } from "../../api/FaceRecognition";
import { bus } from "../../../utils/bus";
import { errorHandler } from "../../../utils/errorHandler";
import ButtonAdd from "../../../components/common/buttons/button-add";
import { nAlert, nSuccess, nError } from "../../../utils/notice";

export default {
  components: {
    ButtonAdd,
    TableMain,
    InputSelect,
    InputSearch,
    ButtonUpload,
    ButtonExport,
    ButtonDelete,
    Breadcrumb
  },
  name: "face-database-management",
  data() {
    return {
      permissionCodes: "",
      breadcrumb: [
        {
          value: "人脸应用",
          name: "monitoring-point-management"
        },
        {
          value: "人脸库管理"
        }
      ],
      typeList: [
        { key: "白名单", value: "白名单" },
        { key: "黑名单", value: "黑名单" }
      ],
      tableHead: [
        {
          prop: "name",
          label: "人脸库名称"
        },
        {
          prop: "type",
          label: "人脸库类型"
        },
        {
          prop: "deviceName",
          label: "摄像头通道"
        },
        {
          prop: "authNumber",
          label: "授权人数"
        }
      ],
      tableData: [],
      operationArr: ["faceAuthorization", "modify", "delete"],
      requestData: {
        searchKey: "",
        pageSize: 10,
        pageNum: 1
      },
      uploadUrl: "",
      total: 0,
      selectionArr: [],
      dialogVisible: false,
      formData: {},
      flag: false,
      cameraList: []
    };
  },
  created() {
    this.permissionCodes = bus.global.permissionCodes;
    this.getPage();
    this.remoteMethod();
  },
  activated() {
    this.getPage();
  },
  methods: {
    remoteMethod() {
      this.getFacePointList();
    },
    getFacePointList() {
      this.$axios
        .post(api.getFacePointList, {})
        .then(res => {
          let data = res.data.data;
          data.map(v => {
            v.key = v.deviceCode;
            v.label = v.name;
          });
          this.cameraList = data;
        })
        .catch(errorHandler("获取摄像机列表失败"));
    },
    getPage() {
      this.$axios
        .post(api.getFaceDBPage, this.requestData)
        .then(res => {
          this.total = res.data.data.total;
          let list = res.data.data.list;
          list.map(v => {
            if (!v.authNumber) {
              v.authNumber = 0;
            }
          });
          this.tableData = list;
        })
        .catch(errorHandler("获取监测点列表失败"));
    },
    deleteLine(code) {
      this.$axios
        .post(api.deleteFaceDB, code)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess("删除成功");
            this.selectionArr = [];
            this.getPage();
          }
        })
        .catch(errorHandler("删除失败"));
    },
    toAddPage() {
      this.formData = {};
      this.dialogVisible = true;
    },
    goToModifyPage(code) {
      this.tableData.map(v => {
        if (v.code == code) {
          this.formData = v;
          this.flag = true;
        }
      });
      this.dialogVisible = true;
    },
    searchKey(v) {
      this.requestData.pageNum = 1;
      this.requestData.searchKey = v;
      this.getPage();
    },
    changePagination(data) {
      this.requestData.pageNum = data[0];
      this.requestData.pageSize = data[1];
      this.getPage();
    },
    confirm() {
      if (!this.formData.name) {
        nError("请选择人脸库名称");
        return false;
      }
      if (!this.formData.type) {
        nError("请选择人脸库类型");
        return false;
      }
      if (!this.formData.deviceCode) {
        nError("请选择摄像机通道");
        return false;
      }

      if (this.flag) {
        this.$axios
          .post(api.updateFaceDB, this.formData)
          .then(res => {
            nSuccess("修改成功");
            this.dialogVisible = false;
            this.flag = false;
            this.formData = {};
            this.getPage();
          })
          .catch(errorHandler("修改失败"));
      } else {
        this.$axios
          .post(api.addFaceDB, this.formData)
          .then(res => {
            nSuccess("添加成功");
            this.dialogVisible = false;
            this.formData = {};
            this.getPage();
          })
          .catch(errorHandler("添加失败"));
      }
    },
    cancel() {
      this.dialogVisible = false;
      this.flag = false;
    },
    faceAuthorizationRow(data) {
      console.log(data);
      if (data.type == "白名单") {
        this.$router.push({
          path: `face_database_authorization/${data.code}`
        });
      } else if (data.type == "黑名单") {
        this.$router.push({
          path: `face_database_authorization_black/${data.code}`
        });
      }
    }
  }
};
</script>


<style scoped>
.search-line {
  display: flex;
  justify-content: space-between;
  margin: 20px 0;
}
</style>



// WEBPACK FOOTER //
// src/view/FaceRecognition/FaceDatabaseManagement/FaceDatabaseManagement.vue